export default __webpack_public_path__ + "static/media/cropped_logo.ba8d0e74.svg";